import { render, staticRenderFns } from "./myData.vue?vue&type=template&id=3a6a76aa&scoped=true&"
import script from "./myData.vue?vue&type=script&lang=js&"
export * from "./myData.vue?vue&type=script&lang=js&"
import style0 from "./myData.vue?vue&type=style&index=0&id=3a6a76aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a76aa",
  null
  
)

export default component.exports